import {
  USERS_DOWNLOADED,
  USERS_RENTERS_DOWNLOADED, // Should actually update users with matching renter_id,
  USERS_FAILED,
  USERS_PENDING,
  USERS_RESET,
  USER_LOGIN,
  USER_SENDING,
  USER_DOWNLOADED,
  WAITING_USERS_DOWNLOADED,
  WAITING_USER_DOWNLOADED,
  WAITING_USER_REMOVED,
  USER_RENTER_REMOVED, WAITING_USERS_PENDING,
} from './types';
import { db } from '../../firebase';
import { ROLE_USER } from '../../constants/roles';
import { handleError } from '../infos/actions';
import RentersApiService from '../../services/api/RentersApiService';
import RentsApiService from '../../services/api/RentsApiService';

// Action creators
export const usersResetAction = () => ({
  type: USERS_RESET,
});
export const usersPendingAction = () => ({
  type: USERS_PENDING,
});
export const userSendingAction = () => ({
  type: USER_SENDING,
});

export const usersDownloadedAction = (users) => ({
  type: USERS_DOWNLOADED,
  payload: users,
});

export const usersRentersDownloadedAction = (userRenters) => ({
  type: USERS_RENTERS_DOWNLOADED,
  payload: userRenters,
});

export const userRenterDeletedAction = (userRenter) => ({
  type: USER_RENTER_REMOVED,
  payload: userRenter,
});

export const waitingUsersDownloadedAction = (waitingUsers) => ({
  type: WAITING_USERS_DOWNLOADED,
  payload: waitingUsers,
});

export const waitingUsersPendingAction = () => ({
  type: WAITING_USERS_PENDING,
});

export const waitingUserDownloadedAction = (waitingUser) => ({
  type: WAITING_USER_DOWNLOADED,
  payload: waitingUser,
});

export const waitingUserDeletedAction = (waitingUser) => ({
  type: WAITING_USER_REMOVED,
  payload: waitingUser,
});

export const userDownloadedAction = (authUserId, user) => ({
  type: USER_DOWNLOADED,
  payload: user,
  userId: authUserId,
});

export const userLoginAction = (user) => ({
  type: USER_LOGIN,
  payload: user,
});

export const usersFailedAction = (error) => ({
  type: USERS_FAILED,
  payload: error,
});

// Actions

export function resetUsers() {
  return (dispatch) => {
    dispatch(usersResetAction());
  };
}

export function getUsers() {
  return (dispatch) => {
    dispatch(usersPendingAction());
    return db
      .getUsers()
      .then((snapshot) => {
        dispatch(usersDownloadedAction(snapshot.val()));
      })
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function getUsersForRenter(authUserToken) {
  return (dispatch) => {
    dispatch(usersPendingAction());
    return RentsApiService
      .getAllUsersByRenter(authUserToken)
      .then((data) => {
        dispatch(usersDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function getUsersRenters() {
  return (dispatch) => {
    dispatch(usersPendingAction());
    return db
      .getUsersRenter()
      .then((snapshot) => {
        dispatch(usersRentersDownloadedAction(snapshot.val()));
      })
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function postUserRenter(inviteToken, newUser) {
  return (dispatch) => {
    dispatch(userSendingAction());
    return RentersApiService
      .postRenterAdmin(inviteToken, newUser)
      .then(() => {
        dispatch(waitingUserDeletedAction(newUser));
      })
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function putUser(authUserId, email, firstname, lastname, mobile) {
  return (dispatch) => {
    dispatch(userSendingAction());
    return db
      .doProfileUpdate(authUserId, email, firstname, lastname, mobile)
      .then(() => {
        const newUser = {
          email,
          firstname,
          lastname,
          mobile,
        };
        dispatch(userDownloadedAction(authUserId, newUser));
        return newUser;
      })
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function getWaitingUsers(authUserToken, renterId) {
  return (dispatch) => {
    dispatch(waitingUsersPendingAction());
    return RentersApiService
      .getWaitingUsers(authUserToken, renterId)
      .then((data) => {
        dispatch(waitingUsersDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function postWaitingUser(authUserToken, renterId, waitingUser) {
  return (dispatch) => {
    dispatch(userSendingAction());
    return RentersApiService
      .postWaitingUser(authUserToken, renterId, waitingUser)
      .then((data) => {
        dispatch(waitingUserDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function deleteWaitingUser(authUserToken, renterId, waitingUser) {
  return (dispatch) => {
    dispatch(userSendingAction());
    return RentersApiService
      .deleteWaitingUser(authUserToken, renterId, waitingUser.email)
      .then(() => {
        dispatch(waitingUserDeletedAction(waitingUser));
      })
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function removeUserRenters(user) {
  return (dispatch) => {
    dispatch(userSendingAction());
    return db
      .removeUserRenter(user.id)
      .then(() => db
        .doRoleUpdate(user.id, ROLE_USER)
        .then(() => {
          dispatch(userRenterDeletedAction(user));
        })
        .catch((error) => {
          dispatch(usersFailedAction(error));
        }))
      .catch((error) => {
        dispatch(usersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/users/actions.js